import Router from "next/router";

import { MessageType, TransMsg } from "../i18n/messages";
import { LocaleText } from "../types/locale";

function getLocaleValue(value: LocaleText, locale?: string) {
  if (!value) return undefined;

  switch (locale) {
    case "en":
      return value.en;
    case "zh-Hant":
      return value.zhHant;
    case "zh-Hans":
      return value.zhHans;
    default:
      return null;
  }
}

function getLocaleValueFallback(value: LocaleText | undefined | null, locale: string) {
  if (!value) return "";

  switch (locale) {
    case "en":
      return getFirst(value.en, value.zhHant, value.zhHans);
    case "zh-Hans":
      return getFirst(value.zhHans, value.zhHant, value.en);
    case "zh-Hant":
      return getFirst(value.zhHant, value.zhHans, value.en);
    default:
      return "";
  }
}

function getFirst(...seq: string[]) {
  for (const item of seq) {
    if (item) return item;
  }

  return "";
}

function isNumber(value: any) {
  if (isNaN(value)) {
    return false;
  } else {
    return true;
  }
}

function getLocaleValueDefault(value: LocaleText) {
  return getLocaleValue(value, Router.locale ?? "");
}

function getLocaleValueDefaultFallback(value: LocaleText | undefined | null) {
  return getLocaleValueFallback(value, Router.locale ?? "");
}

function getHKD(value: number) {
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "HKD",
  });

  if (!value) {
    return undefined;
  }
  return formatter.format(value);
}

function isEmpty(value: LocaleText) {
  if (!value) return false;
  if (!value.en) return false;
  if (!value.zhHans) return false;
  if (!value.zhHant) return false;
  return true;
}

function getLocaleLabel(locale: string, t: (msg: TransMsg) => string, msg: MessageType) {
  switch (locale) {
    case "en":
      return t(msg.setting.english);
    case "zh-Hant":
      return t(msg.setting.chineseT);
    case "zh-Hans":
      return t(msg.setting.chineseS);
  }
}

const localeCore = {
  getLocaleValue,
  getLocaleValueFallback,
  getLocaleValueDefault,
  getLocaleValueDefaultFallback,
  getLocaleLabel,
  isEmpty,
  getHKD,
  isNumber,
};

export default localeCore;
